import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { productIdZodSchema } from "@@/shared/products/product-id";
import { skuIdZodSchema } from "@@/shared/products/sku-id";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import type { Except } from "type-fest";
import z from "zod";

const stockBalanceSkuSetCommandZodSchema = z.object({
    _type: z.literal("STOCK_BALANCE_SKU_SET_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    currentVersion: z.number().int().min(1),
    providerId: providerIdZodSchema,
    productId: productIdZodSchema,
    skuId: skuIdZodSchema,
    quantity: z.number().int().min(0),
});

type StockBalanceSkuSetCommand = z.infer<
    typeof stockBalanceSkuSetCommandZodSchema
>;

type FactoryParams = Except<StockBalanceSkuSetCommand, "_type" | "_createdAt">;
const stockBalanceSkuSetCommandFactory = (
    params: FactoryParams,
): StockBalanceSkuSetCommand => {
    return {
        ...params,
        _type: "STOCK_BALANCE_SKU_SET_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
};
export { stockBalanceSkuSetCommandFactory, stockBalanceSkuSetCommandZodSchema };
export type { StockBalanceSkuSetCommand };
